import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyCfbv9kwxQCJqjm2ipgFg_AzuO8RmHAw_4",
    authDomain: "spe-bue.firebaseapp.com",
    databaseURL: "https://spe-bue.firebaseio.com",
    projectId: "spe-bue",
    storageBucket: "spe-bue.appspot.com",
    messagingSenderId: "1001298008379",
    appId: "1:1001298008379:web:5b7f3723023192e1a07f1e",
    measurementId: "G-93GB8XZ4F2"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(<App />, document.getElementById('root'));